import { isAndroidWebView, isLinux } from '@eventbrite/feature-detection';
import { TicketsFormat } from '../constants/statsig';

export const getSupportedTicketFormat = (): TicketsFormat => {
    // TODO: EB-208841 - Exclude Linux until it is supported
    return isLinux() && !isAndroidWebView()
        ? TicketsFormat.listItem
        : TicketsFormat.card;
};
